// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2yZpv","link":"PrivacyPolicy_link__CXEQc"};